import { gql } from '@apollo/client';

const schema = {
  ready: {
    name: 'createRequest',
    serviceName: 'auth',
    query: gql`
      mutation createRequest(
        $type: String!
        $info: String
        $status: String
        $details: String
        $shop_id: String
        $unit_id: String
        # $user_id: String
        # $do_date: String
        $booth_id: String
        $order_id: String
        $coupon_id: String
        $product_id: String
        $for_role_id: String
        $for_user_id: String
        $for_shop_id: String
        # $request_date: String
        $settlement_id: String
        $product_shop_id: String
      ) {
        createRequest(
          type: $type
          info: $info
          status: $status
          details: $details
          shop_id: $shop_id
          unit_id: $unit_id
          # user_id: $user_id
          # do_date: $do_date
          booth_id: $booth_id
          order_id: $order_id
          coupon_id: $coupon_id
          product_id: $product_id
          for_role_id: $for_role_id
          for_user_id: $for_user_id
          for_shop_id: $for_shop_id
          # request_date: $request_date
          settlement_id: $settlement_id
          product_shop_id: $product_shop_id
        ) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
